import React, { useEffect } from 'react';
import '../App.css';

// 완전히 단순화된 컴포넌트 - API 호출이나 리디렉션 없음
const StateStop: React.FC = () => {
  useEffect(() => {
    document.title = '시스템 접근 제한';
  }, []);

  return (
    <div className="state-stop-container">
      <div className="state-stop-content">
        <h1>시스템 접근 제한</h1>
        <p>현재 Withcookie 서비스 계약 만료/일시중지로 접근이 제한되었습니다.<br />갱신 또는 재계약은 아래 사이트를 통해 문의 바랍니다.</p>
        <a href="https://withcookie.com" style={{ background: '#2222ee', color:'white', padding: '10px 20px', borderRadius: '5px', fontWeight: 'bold' }}>위드쿠키 서비스</a>
      </div>
    </div>
  );
};

export default StateStop; 